/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ── Cart drawer colour overrides ───────────────────────────────────────
  var cartStyles = document.createElement('style');
  cartStyles.textContent = [
    /* Top announcement banner inside cart drawer */
    '.cart-message--custom { background-color: #C11E57 !important; color: #D3E067 !important; }',
    '.cart-message--custom * { color: #D3E067 !important; }',
    /* Free-shipping progress bar */
    '.cart-message__progress { color: #C11E57 !important; accent-color: #C11E57 !important; }',
    '.cart-message__progress::-webkit-progress-value { background-color: #C11E57 !important; }',
    '.cart-message__progress::-webkit-progress-bar { background-color: rgba(193,30,87,0.15) !important; }',
    /* Loading bar */
    '.loader--line { background-color: rgba(193,30,87,0.08) !important; }',
    '.loader-indeterminate { background-color: #C11E57 !important; }',
    /* "Apply" discount button */
    '.btn--apply-discount { background-color: #C11E57 !important; border-color: #C11E57 !important; color: #D3E067 !important; }',
    /* "You're saving…" savings banner & automatic-discount chip */
    '.cart__discount { background-color: #000000 !important; color: #ffffff !important; }',
    '.cart__discount * { color: #ffffff !important; }'
  ].join('\n');
  document.head.appendChild(cartStyles);

  // ── Clarity: Cart drawer abandonment tracking ──────────────────────────
  function initClarityCartTracking() {
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;

    var cartOpened      = false;
    var checkoutClicked = false;

    // MutationObserver watches for class changes on the cart drawer element
    // Palo Alto removes/adds classes to show and hide the drawer
    var lastHidden = cartDrawer.classList.contains('cv-h') ||
                     cartDrawer.classList.contains('hidden') ||
                     !cartDrawer.classList.contains('is-visible');

    var observer = new MutationObserver(function() {
      var isHidden = cartDrawer.classList.contains('cv-h') ||
                     cartDrawer.classList.contains('hidden') ||
                     !cartDrawer.classList.contains('is-visible');

      if (!isHidden && lastHidden) {
        // Drawer just opened
        cartOpened      = true;
        checkoutClicked = false;
      } else if (isHidden && !lastHidden && cartOpened) {
        // Drawer just closed without checkout
        if (!checkoutClicked && typeof clarity === 'function') {
          clarity('event', 'cart_abandonment');
        }
        cartOpened = false;
      }

      lastHidden = isHidden;
    });

    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

    // Also listen for the checkout button click inside the drawer
    document.addEventListener('click', function(e) {
      var checkoutBtn = e.target.closest(
        '[data-cart-checkout-button] button, button[name="checkout"], [data-cart-form] button[type="submit"]'
      );
      if (checkoutBtn) {
        checkoutClicked = true;
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClarityCartTracking);
  } else {
    initClarityCartTracking();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
